module.exports = __webpack_public_path__ + "static/media/logo-small.80772ab0.png";